import { storage } from "@/lib/local-storage";

export type ShipperOnboardingTodoId = "email" | "profile" | "container" | "document" | "askEve";

const OVERRIDES_KEY = "shipper.controlHub.onboardingTodoOverrides";
const DOCUMENT_VIEWED_KEY = "shipper.onboarding.documentViewed";
const ASK_EVE_PROMPT_KEY = "shipper.onboarding.askEvePrompt";

function readOverrides(): Partial<Record<ShipperOnboardingTodoId, boolean>> {
    try {
        const raw = storage.getItem(OVERRIDES_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw) as unknown;
        if (!parsed || typeof parsed !== "object") return {};
        return parsed as Partial<Record<ShipperOnboardingTodoId, boolean>>;
    } catch {
        return {};
    }
}

export function getTodoOverride(id: ShipperOnboardingTodoId): boolean | undefined {
    return readOverrides()[id];
}

/** done = override true, or (override !== false && auto). */
export function isTodoDone(id: ShipperOnboardingTodoId, auto: boolean): boolean {
    const o = getTodoOverride(id);
    if (o === false) return false;
    if (o === true) return true;
    return auto;
}

function notifyOnboardingChanged(): void {
    if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent("shipper-onboarding-changed"));
    }
}

export function setTodoOverride(id: ShipperOnboardingTodoId, done: boolean): void {
    const next = { ...readOverrides(), [id]: done };
    storage.setItem(OVERRIDES_KEY, JSON.stringify(next));
    notifyOnboardingChanged();
}

export function markShipperDocumentViewedForOnboarding(): void {
    storage.setItem(DOCUMENT_VIEWED_KEY, "1");
    notifyOnboardingChanged();
}

export function hasShipperDocumentViewedForOnboarding(): boolean {
    return storage.getItem(DOCUMENT_VIEWED_KEY) === "1";
}

export function markShipperAskEvePromptForOnboarding(): void {
    storage.setItem(ASK_EVE_PROMPT_KEY, "1");
    notifyOnboardingChanged();
}

export function hasShipperAskEvePromptForOnboarding(): boolean {
    return storage.getItem(ASK_EVE_PROMPT_KEY) === "1";
}
